import { render, staticRenderFns } from "./SiteGroupDirectoriesConfig.vue?vue&type=template&id=10946226&"
import script from "./SiteGroupDirectoriesConfig.vue?vue&type=script&lang=js&"
export * from "./SiteGroupDirectoriesConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports